import { OrderTrackPageListTable } from "./OrderTrackPageListTable";

export default OrderTrackPageListTable;
